export default {
    CHANGE: '@__change_hw_data',
    INIT_TEMPLATES_NAME: '@__INIT_TEMPLATES_NAME',
    INIT_STUDENTS_LIST: '@__INIT_STUDENTS_LIST',
    INIT_CALENDAR_TASKS: '@__INIT_CALENDAR_TASKS',
    CLEAR_HW_DATA: '@__CLEAR_HW_DATA',
    SET_TEMPLATES_NAME: '@__SET_TEMPLATES_NAME',
    HIDE_SUBMIT_BUTTON: '@__HIDE_SUBMIT_BUTTON',
    INIT_CUSTOM_TOPICS: '@__INIT_CUSTOM_TOPICS',
};
